import { Column, Grid, Link, MarkdownRenderer } from '@aurora-components';
import { type FragmentType, getFragmentData } from '@gql';
import { Text } from '../../aurora/text/text';
import { VildarCardSectionCardsFragment, VildarCardSectionFragment } from './card-section-gql';
import {
  CardSectionContainer,
  CardSectionWrapper,
  DisplayTitleWrapper,
  Heading,
  Sidebar,
  SidebarContainer,
} from './card-section.styles';
import Cards from './cards';

type Props = FragmentType<typeof VildarCardSectionFragment>;

export function CardsSection(props: Props) {
  const { cards } = getFragmentData(VildarCardSectionFragment, props);
  if (cards?.card_sectionConnection?.edges?.length === 0) return null;
  const {
    sidebar,
    card_template: cardTemplate,
    pagination,
    post_limit,
    display_title: displayTitle,
    paragraph,
    type,
    link,

    ...section
    // eslint-disable-next-line react-hooks/rules-of-hooks
  } = getFragmentData(VildarCardSectionCardsFragment, cards!.card_sectionConnection!.edges![0]!.node!);

  const SectionTitle = (
    <>
      {displayTitle && (
        <DisplayTitleWrapper $isPeopleCard={cardTemplate === 'person'}>
          <Text $variant="h3" $color="primary-base100" $noBalancer $truncateVertical>
            {displayTitle}
          </Text>
        </DisplayTitleWrapper>
      )}
      {paragraph && (
        <MarkdownRenderer
          $variant="p"
          $color="primary-base100"
          $fontWeight="Light"
          $noBalancer
          $truncateVertical
          markdown={paragraph}
        />
      )}
    </>
  );
  return (
    <CardSectionWrapper>
      {!sidebar && <Heading>{SectionTitle}</Heading>}
      <CardSectionContainer>
        <Grid $fullWidth={true}>
          {sidebar ? (
            <Column $span={{ xs: 12, md: 4 }}>
              <SidebarContainer>
                <Sidebar>{SectionTitle}</Sidebar>
                {link?.internal_urlConnection?.edges?.length ? (
                  <Link
                    variant="with-arrow"
                    title={link.internal_urlConnection.edges[0]?.node?.navigation_title || ''}
                    url={link.internal_urlConnection.edges[0]?.node?.url || ''}
                  />
                ) : (
                  <></>
                )}
              </SidebarContainer>
            </Column>
          ) : (
            <></>
          )}
          <Column $horizontalAlign="center" $span={{ xs: 12, md: sidebar ? 8 : 12 }}>
            <Cards
              {...section}
              cardTemplate={cardTemplate}
              type={type}
              postLimit={post_limit}
              pagination={pagination || false}
            />
          </Column>
          <Column $horizontalAlign="center" $verticalAlign="end" $span={{ xs: 12, md: 0, lg: 0, xl: 0, xxl: 0 }}>
            {link?.internal_urlConnection?.edges?.length ? (
              <Link
                variant="with-arrow"
                title={link.internal_urlConnection.edges[0]?.node?.navigation_title || ''}
                url={link.internal_urlConnection.edges[0]?.node?.url || ''}
              />
            ) : (
              <></>
            )}
          </Column>
        </Grid>
      </CardSectionContainer>
    </CardSectionWrapper>
  );
}
